const _ = require('underscore');
const React = require("react");
const createReactClass = require("create-react-class");

const form = require('../../../deploynaut/js/Form.jsx');

const AirbrakeForm = createReactClass({
	getInitialState: function() {
		const state = {
			id: null,
			projectId: "",
			projectKey: ""
		};

		const integration = this.props.integration;
		if (integration && integration.options !== undefined) {
			state.id = integration.id;
			state.projectId = integration.options.ProjectID;
			state.projectKey = integration.options.ProjectKey;
		}

		return state;
	},

	render() {
		return (
			<div className="integration-form">
				<p>
					Enabling the Airbrake integration helps identify relationships between your deployments and your errors
					in <a href='https://airbrake.io' target="_new">Airbrake</a>.
				</p>

				<form.Form
					ref="airbrakeForm"
					url={this.props.model.UpdateURL}
					securityID={this.props.model.InitialSecurityID}
					buttonTitle="Save"
					buttonSubmittingTitle="Saving"
					afterSuccess={this.props.afterSuccess}
				>
					<div className="form-group">
						<label htmlFor="ProjectID">Project ID</label>
						<form.Input
							name="ProjectID"
							required
							validationError="Please enter a valid Project ID"
							placeholder="Project ID"
							value={this.state.projectKey}
						/>
					</div>
					<div className="form-group">
						<label htmlFor="ProjectKey">Project Key</label>
						<form.Input
							name="ProjectKey"
							required
							validationError="Please enter a valid Project Key"
							placeholder="Project Key"
							value={this.state.projectKey}
						/>
					</div>

					<form.Hidden name="Type" value="Airbrake" />
					<form.Hidden name="ID" value={this.state.id} />
				</form.Form>
			</div>
		);
	}
});

module.exports = AirbrakeForm;

